// todo 暂时无引用，已从接口返回
const dialectColumns = [
	{ text: '女声普通话', value: 'xiaoyan' },
	{ text: '男声普通话', value: 'xiaoyu' },
	{ text: '童声普通话', value: 'nannan' },
	{ text: '女声粤语', value: 'xiaomei' },
	{ text: '台湾国语', value: 'xiaolin' },
	{ text: '女声四川话', value: 'xiaorong' },
	{ text: '女声东北话', value: 'xiaoqian' },
	{ text: '男声河南话', value: 'xiaokun' },
	{ text: '男声湖南话', value: 'xiaoqiang' },
	{ text: '女声陕西话', value: 'vixying' },
	{ text: '蜡笔小新', value: 'xiaoxin' },
	{ text: '女声英文', value: 'vimary' },
	{ text: '男声英文', value: 'henry' },
];

const positionColumns = [
	{ text: '底部', value: 'bottom' },
	{ text: '居中', value: 'center' },
	{ text: '顶部', value: 'top' },
];

//  + 解决nutui报错
const effectColumns = [
	{ text: '随机', value: '+1000' },
	{ text: '右进左出', value: '+1' },
	{ text: '下进上出', value: '+2' },
	{ text: '左进右出', value: '+3' },
	{ text: '上进下出', value: '+4' },
	{ text: '淡入淡出', value: '+5' },
	{ text: '左滑右出', value: '+6' },
	{ text: '上滑下出', value: '+7' },
	{ text: '缩放渐入', value: '+8' },
	{ text: '翻转旋进', value: '+9' },
	{ text: '螺旋进入', value: '+10' },
	{ text: '左上切入', value: '+11' },
	{ text: '压缩旋出', value: '+12' },
	{ text: '缩放渐入', value: '+13' },
	{ text: '左上切出', value: '+14' },
	{ text: '无', value: '+0' },
];

const trackEffectColumns = [
	{ text: '轨迹重复', value: 'tracking' },
	{ text: '无', value: 'none' },
];

const angleColumns = [
	{ text: '竖屏', value: 'portrait' },
	{ text: '横屏', value: 'landscape' },
];
const appSelfRuncolumns = [
	{ text: '开启', value: 'on' },
	{ text: '关闭', value: 'off' },
];

const yearColumns = [
	{ text: '一年期', value: '1' },
	{ text: '付两年享三年', value: '2' },
	{ text: '付三年享终身', value: '3' },
];

const picOrderColumns = [
	{ text: '按排序', value: 'inorder' },
	{ text: '随机', value: 'random' },
];

const createOrderColumns = (length) => {
	const orderColumns = [];
	for (let i = 0; i < length; i++) {
		orderColumns.push({
			text: i + '',
			value: i + '',
		});
	}

	return orderColumns;
};

export {
	dialectColumns,
	positionColumns,
	effectColumns,
	trackEffectColumns,
	angleColumns,
	appSelfRuncolumns,
	yearColumns,
	picOrderColumns,
	createOrderColumns,
};
